/* eslint-disable max-len */
import React from 'react';

const Loading = ({ size, fill }:{ size?: number, fill?:string }) => (
  <div className="rotate">
    <svg height={size} width={size} viewBox="0 0 24 24">
      <g fill={`var(--${fill})`}>
        <path
          d="M20.093 16.625l-1.122-.642a.642.642 0 01-.28-.774 7.42 7.42 0 11-5.987-10.595l-.09-.008C12.272 4.578 12 4.31 12 3.967v-1.29c0-.346.273-.63.619-.645C12.413 2.019 12.209 2 12 2 6.476 2 2 6.476 2 12s4.476 10 10 10c3.952 0 7.356-2.296 8.98-5.622a.643.643 0 01-.887.247z"
          opacity=".6"
        />
        <path
          d="M12.614 4.606C12.272 4.578 12 4.31 12 3.967V2.675c0-.368.31-.677.676-.652C17.884 2.37 22 6.704 22 12a9.92 9.92 0 01-1.008 4.365.643.643 0 01-.898.26l-1.122-.642c-.299-.17-.397-.538-.25-.85.46-.98.698-2.05.697-3.133a7.42 7.42 0 00-6.805-7.394z"
        />
      </g>
    </svg>
  </div>
);

Loading.defaultProps = {
  fill: 'black',
  size: 24,
};

export default Loading;
